import { render, staticRenderFns } from "./IconSecrecy.vue?vue&type=template&id=6ced9bcc&"
import script from "./IconSecrecy.vue?vue&type=script&lang=js&"
export * from "./IconSecrecy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports